const { GetBuildStoryblokAccessToken, GetBuildStoryblokVersion } = require("./src/utils/env")


console.log(`[Storyblok] Node environment set to ${process.env.NODE_ENV}`)

module.exports = {
    trailingSlash: "always",
    siteMetadata: {
        title: `Start Responsible`,
        siteUrl: `https://www.startresponsible.com/`,
    },
    plugins: [
        `gatsby-plugin-sass`,
        `gatsby-plugin-styled-components`,
        `gatsby-plugin-react-helmet`,
        `gatsby-plugin-image`,
        {
            resolve: "gatsby-plugin-netlify",
            options: {
                mergeSecurityHeaders: true,
                headers: {
                    '/*': [
                        "Content-Security-Policy: frame-ancestors 'self' https://*.storyblok.com/",
                        "X-Frame-Options: ALLOW FROM https://app.storyblok.com/"
                    ]
                }
            }
        }, {
            resolve: `gatsby-source-filesystem`,
            options: {
                name: `images`,
                path: `${__dirname}/src/images`
            },
        },
        `gatsby-transformer-sharp`,
        `gatsby-plugin-sharp`,
        {
            resolve: `gatsby-plugin-manifest`,
            options: {
                name: `start-aluminum`,
                short_name: `start`,
                start_url: `/`,
                background_color: `#663399`,
                // This will impact how browsers show your PWA/website
                // https://css-tricks.com/meta-theme-color-and-trickery/
                // theme_color: `#663399`,
                display: `minimal-ui`,
                icon: `src/images/start-icon-green.png`, // This path is relative to the root of the site.
            },
        },
        {
            resolve: 'gatsby-source-storyblok',
            // parse release function:
            // if context and branch then switch branch match with release otherwise return 0
            options: {
                accessToken: GetBuildStoryblokAccessToken(),
                version: GetBuildStoryblokVersion(),
                homeSlug: "home",
                languages: ['en', 'fr'], //Omission retrieves all languages by default
                resolveRelations: ["featured_event.event"], // Make sure this matches the storyblok.js draft api call as well
                includeLinks: true
            }
        },
        {
            resolve: "gatsby-plugin-google-tagmanager",
            options: {
                id: "GTM-M6FLHLW",
                includeInDevelopment: true,
                defaultDataLayer: { platform: "gatsby" },
            }
        }
    ],
}